module.exports = __webpack_public_path__ + "img/pro_beijia_03_l.ed353cf6.png";